import './App.css';
import Api from './Service/api';
import PaymentList from './Pages/PaymentList';
import NMIFile from './Pages/NewPaymentMethods/NMI';
import { createContext, useEffect, useState } from 'react';
import { Translator, LanguageList, Config, T } from './app-utils/translator'
import { AntdFeedbackProvider } from './app-utils/antdFeedback';
import WorldPay from './Pages/NewPaymentMethods/WorldPay';

const api = new Api();
export const AutoShipContext = createContext(null);
export const LoadingContext = createContext(null);
export const ProfileContext = createContext(null);

function App() {

  const [lang, setLang] = useState('en');
  const [profileData, setProfileData] = useState();
  const [loading, setLoading] = useState();
  const [autoShipDetails, setAutoShipDetails] = useState();
  const [defaultConnectorJPY, setDefaultConnectorJPY] = useState({});
  const [domainDetails, setDomainDetails] = useState();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    
    const body = {
      language: params.get('lang'),
      currency: params.get('currency'),
      redirectUrl: params.get('redirect_url'),
      requestReference: params.get('request_reference'),
      type: Number(params.get('type')),
      autoshipExternalId: params.get('autoshipExternalId'),
      marketUuid: params.get('marketUuid') ?? '',
      autoshipReference: params.get('autoship_reference') ?? '',
      autoshipProvider: params.get('autoshipProvider') ?? '',
    };
    setAutoShipDetails(body);
    getProfileData();
    sessionStorage.setItem('token', params.get('token'));
    setLanguageSpecific(body?.language);
    getDomainUrl()
  }, []);

  useEffect(() => {
    if(profileData && autoShipDetails && autoShipDetails.type === 2) {
      getDefaultConnector(autoShipDetails?.currency);
    }
  }, [profileData, autoShipDetails]);

  const getDefaultConnector = async(currency) => {
    setLoading(true);
    const url = `external/connector/${currency}`;
    const result = await api.mainRestCallService(url, 'GET');
    setLoading(false);
    if (result?.status) {
      setDefaultConnectorJPY(result.data[0]);
    }
  }

  const getDomainUrl = async() => {
    setLoading(true);
    const url = `external/domain`;
    const result = await api.mainRestCallService(url, 'GET');
    setLoading(false);
    if (result?.status && result.data) {
      var data = JSON.parse(JSON.stringify(result.data));
      setDomainDetails(JSON.parse(data));
    }
  }

  const getProfileData = async () => {
    let result = await api.mainRestCallService('external/profile', 'GET');
    if (result && result.status === 1) {
      setProfileData((profileData) => ({ ...profileData, ...result.data, hkcm: result?.data?.hkcm, 'distributorId': result?.data?.distributorId, invalidDomainError: false }) );
    } else if (result && result.error.message === 'error.invalid.domain') {
      setProfileData((profileData) => ({ ...profileData, 'invalidDomainError': true }) );
    }
}

  const setLanguageSpecific = (fullLang) => {
    var search = fullLang?.split('-')[0]?.toLowerCase();
    var searchSuffix = fullLang?.split('-')[1]?.toLowerCase();
    if (search === 'en') {
      setLang('en');
      Config.default = 'en';
    } else if ((search === 'zh' && (searchSuffix === 'cn' || searchSuffix === 'hk')) || search === 'cn') {
      setLang('znch');
      Config.default = 'znch';
    } else if ((search === 'zh' && searchSuffix === 'tw')) {
      setLang('zhcht');
      Config.default = 'zhcht';
    } else if (search === 'ms') {
      setLang('ms');
      Config.default = 'ms';
    } else if (search === 'es') {
      setLang('es');
      Config.default = 'es';
    } else if (search === 'th') {
      setLang('th');
      Config.default = 'th';
    } else {
      setLang('en');
      Config.default = 'en';
    }
  }


  Config.list = {
    en: {
      text: "English",
      file: require("./assets/i18n/en")
    },
    znch: {
      text: "chinese(Simplified)",
      file: require("./assets/i18n/zn-ch")
    },
    zhcht: {
      text: "chinese(Traditional)",
      file: require("./assets/i18n/zh-CHT")
    },
    ms: {
      text: "Malay",
      file: require("./assets/i18n/ms")
    },
    es: {
      text: "Spanish",
      file: require("./assets/i18n/es")
    },
    th: {
      text: "Thai",
      file: require("./assets/i18n/th")
    },
  };

  return (
    <AutoShipContext.Provider value={{ autoShipDetails, setAutoShipDetails }}>
       <ProfileContext.Provider value={{ profileData }}>
      {
        (autoShipDetails) &&
        <LoadingContext.Provider value={{ loading, setLoading }}>
          <Translator>
            <AntdFeedbackProvider>
              <div>
                {
                  (loading) &&
                  <div className="loader_div">
                    <div className="text-center">
                      <img src="https://media.tenor.com/On7kvXhzml4AAAAj/loading-gif.gif" alt="loader" />
                      <p style={{ color: 'white', marginTop: 10 }}>{T('loadingText')}</p>
                    </div>
                  </div>
                }
                <div className="listViewDiv">
                  <div className="App bodyWidth">
                    <div className="">
                      <img 
                        src={
                          domainDetails && domainDetails.logo 
                            ? domainDetails.cdnDomain.concat(domainDetails.logo) 
                            : 'https://d2bibd1b1uy3k1.cloudfront.net/newulifeLogo_v2.png'
                        } 
                        alt="logo" 
                        style={{width: '200px'}}
                      />
                    </div>
                    {(autoShipDetails?.type === 1) && <PaymentList />}
                    {(autoShipDetails?.type === 2 && defaultConnectorJPY.displayName === 'NMI') && <NMIFile connector={defaultConnectorJPY} /> }
                    {(autoShipDetails?.type === 2 && defaultConnectorJPY.displayName === 'WORLDPAY') && <WorldPay connector={defaultConnectorJPY} /> }
                  </div>
                </div>
              </div>
              <LanguageList Language={lang} />
            </AntdFeedbackProvider>
          </Translator>
        </LoadingContext.Provider>
      }
      </ProfileContext.Provider>
    </AutoShipContext.Provider>
  );
}

export default App;
